/** Helpers de horário em minutos das seções da mesa (expediente + agendadas). */

/**
 * Minuto do dia → "HH:MM". O wrap %1440 faz 1440 (fim do dia, usado no
 * expediente) virar "00:00"; para 0..1439 (atividades agendadas) é identidade.
 */
export function minuteToHHMM(minute: number): string {
  const m = minute % 1440;
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
}

/** "HH:MM" → minuto do dia; null se inválido. No campo de FIM do expediente, "00:00" significa meia-noite (1440). */
export function hhmmToMinute(value: string, opts?: { endOfDay?: boolean }): number | null {
  const match = /^(\d{2}):(\d{2})$/.exec(value);
  if (!match) return null;
  const minute = Number(match[1]) * 60 + Number(match[2]);
  if (minute > 1440) return null;
  if (opts?.endOfDay && minute === 0) return 1440;
  return minute;
}
